// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DTCC","content":"styles_content__lxipI"};